import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, PropType, onMounted, watch } from 'vue';
import { CloseBold } from '@element-plus/icons-vue';
import { PUSH_TYPE_MAP, MI_PUSH, OPPO_PUSH, VIVO_PUSH, COMMON_PUSH, CONFIG_MAPPING, CONFIG_TYPES, NOTIFICATION_TYPES, PUSH_TYPES, PUSH_VOIP_TYPES } from '../constance';
import { AppType, FormDataType } from '@/views/applications/types';
import { ElMessage } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  __name: 'addConfig',
  props: {
  addVisible: {
    type: Boolean,
    default: false,
  },
  appInfo: {
    type: Object as PropType<AppType>,
    default: () => { },
  },
},
  emits: ['confirm', 'close'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emits = __emit;

const props = __props;

const configType = ref('');
const pushType = ref('');
const formData = ref<FormDataType>({});
const formRef = ref();

const pushTypeList = computed(() => {
  if (configType.value === 'oneSignalConfig') {
    return props.appInfo.hasVOIP ? PUSH_VOIP_TYPES : PUSH_TYPES;
  }
  if (configType.value === 'jConfig') {
    return COMMON_PUSH;
  }
  if (configType.value === 'oppoConfig') {
    return OPPO_PUSH;
  }
  if (configType.value === 'vivoConfig') {
    return VIVO_PUSH;
  }
  if (configType.value === 'miConfig') {
    return MI_PUSH;
  }
  if (configType.value === 'hmsConfig') {
    return COMMON_PUSH;
  }
  if (configType.value === 'callbackUrls') {
    return NOTIFICATION_TYPES;
  }
});

const currentFormConfig = computed(() => {
  return CONFIG_MAPPING[pushType.value].fields || [];
});


const handleConfigTypeChange = (value: string) => {
  pushType.value = '';
  formData.value = {};
  let configList: any[] = [];

  switch (value) {
    case 'oneSignalConfig':
    case 'jConfig':
    case 'hmsConfig':
    case 'miConfig':
    case 'oppoConfig':
    case 'vivoConfig':
      configList = props.appInfo[value];
      break;
    case 'callbackUrls':
      configList = props.appInfo[value] || [];
      break;
    default:
      console.error('未知的配置类型:', value);
      return;
  }
  /*
    pushTypeList.value!.forEach((item) => {
      let isDisabled = false;

      for (const config of configList) {
        if (
          (value === 'oneSignalConfig' || value === 'jConfig') &&
          ((item.value === 'iosOrdinary' && config.configType === 0 && config.pushPlateform === 1) ||
            (item.value === 'iosVOIP' && config.configType === 1 && config.pushPlateform === 1) ||
            (item.value === 'androidOrdinary' && config.configType === 0 && config.pushPlateform === 0) ||
            (item.value === 'androidVOIP' && config.configType === 1 && config.pushPlateform === 0))
        ) {
          isDisabled = true;
          break;
        } else if (value === 'hmsConfig' && item.value === 'commonPush' && config.configType === 0 && config.pushPlateform === 0) {
          isDisabled = true;
          break;
        } else if (value === 'callbackUrls' && configList.length > 0) {
          isDisabled = true;
          break;
        }
      }

      item.disabled = isDisabled;
    });*/
};

// 处理推送类型变化
const handlePushTypeChange = (val: string) => {
  currentFormConfig.value.forEach((item) => {
    formData.value[item.model] = '';
  });
};

//当失去焦点的时候去除字符串的前后空格
const onInputBlur = (model: string) => {
  if (typeof formData.value[model] === 'string') {
    formData.value[model] = formData.value[model].trim();
  }
};

//表单提交事件
const submit = async () => {
  if (!formRef.value) return;
  await formRef.value.validate((valid: boolean) => {
    if (valid) {
      // 校验同一配置类型下应用包名不能重复
      const needCheckBundleId = [
        'oneSignalConfig', 'jConfig', 'hmsConfig', 'miConfig', 'oppoConfig', 'vivoConfig'
      ];
        const configList = (props.appInfo as any)[configType.value] || [];
      let config;
      if (configType.value === 'oneSignalConfig' || configType.value === 'jConfig') {
        if (pushType.value === 'iosOrdinary') {
          const exist = (configList as any[]).some((item: any) => item.bundleId === formData.value.bundleId && item.configType ===0 && item.pushPlateform === 1);
          if (exist) {
            ElMessage.warning('不能重复添加相同的应用包名');
            return;
          }
          config = {
            ...formData.value,
            configType: 0,
            pushPlateform: 1,
          };
        }
        if (pushType.value === 'iosVOIP') {
           const exist = (configList as any[]).some((item: any) => item.bundleId === formData.value.bundleId && item.configType ===1 && item.pushPlateform === 1);
          if (exist) {
            ElMessage.warning('不能重复添加相同的应用包名');
            return;
          }
          config = {
            ...formData.value,
            configType: 1,
            pushPlateform: 1,
          };
        }
        if (pushType.value === 'androidOrdinary') {
           const exist = (configList as any[]).some((item: any) => item.bundleId === formData.value.bundleId && item.configType ===0 && item.pushPlateform === 0);
          if (exist) {
            ElMessage.warning('不能重复添加相同的应用包名');
            return;
          }
          config = {
            ...formData.value,
            configType: 0,
            pushPlateform: 0,
          };
        }
        if (pushType.value === 'androidVOIP') {
           const exist = (configList as any[]).some((item: any) => item.bundleId === formData.value.bundleId && item.configType ===1 && item.pushPlateform === 0);
          if (exist) {
            ElMessage.warning('不能重复添加相同的应用包名');
            return;
          }
          config = {
            ...formData.value,
            configType: 1,
            pushPlateform: 0,
          };
        }
      }
      if (configType.value === 'hmsConfig') {
        if (pushType.value === 'commonPush') {
           const exist = (configList as any[]).some((item: any) => item.bundleId === formData.value.bundleId && item.configType ===0 && item.pushPlateform === 0);
          if (exist) {
            ElMessage.warning('不能重复添加相同的应用包名');
            return;
          }
          config = {
            ...formData.value,
            configType: 0,
            pushPlateform: 0,
          };
        }
      }
      if (configType.value === 'miConfig') {
        if (pushType.value === 'miPush') {
           const exist = (configList as any[]).some((item: any) => item.bundleId === formData.value.bundleId && item.configType ===0 && item.pushPlateform === 0);
          if (exist) {
            ElMessage.warning('不能重复添加相同的应用包名');
            return;
          }
          config = {
            ...formData.value,
            configType: 0,
            pushPlateform: 0,
          };
        }
      }
      if (configType.value === 'oppoConfig') {
        if (pushType.value === 'oppoPush') {
           const exist = (configList as any[]).some((item: any) => item.bundleId === formData.value.bundleId && item.configType ===0 && item.pushPlateform === 0);
          if (exist) {
            ElMessage.warning('不能重复添加相同的应用包名');
            return;
          }
          config = {
            ...formData.value,
            configType: 0,
            pushPlateform: 0,
          };
        }
      }
      if (configType.value === 'vivoConfig') {
        if (pushType.value === 'vivoPush') {
           const exist = (configList as any[]).some((item: any) => item.bundleId === formData.value.bundleId && item.configType ===0 && item.pushPlateform === 0);
          if (exist) {
            ElMessage.warning('不能重复添加相同的应用包名');
            return;
          }
          config = {
            ...formData.value,
            configType: 0,
            pushPlateform: 0,
          };
        }
      }
      if (configType.value === 'callbackUrls') {
        config = [
          { callbackUrlType: 1, url: formData.value.onlineStatus },
          { callbackUrlType: 2, url: formData.value.voiceStatus },
        ];
      }
      emits('confirm', config, configType.value);
      formRef.value.resetFields();
      handleClose();
    }
  });
};


//关闭并且重置弹窗数据
const handleClose = () => {
  configType.value = '';
  pushType.value = '';
  formData.value = {};
  emits('close');
};


const __returned__ = { emits, props, configType, pushType, formData, formRef, pushTypeList, currentFormConfig, handleConfigTypeChange, handlePushTypeChange, onInputBlur, submit, handleClose, get CloseBold() { return CloseBold }, get PUSH_TYPE_MAP() { return PUSH_TYPE_MAP }, get CONFIG_TYPES() { return CONFIG_TYPES } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})